import React from 'react'
import styled from 'styled-components'
import Icon from 'react-fontawesome'

import Color from 'helpers/Color'

const Wrapper = styled.div`
  width: 100%;
  height: ${({height}) => height ? `${height}px` : 'auto'};
  text-align: center;
  padding: 20px;
  background-color: white;
  border-radius: 10px;
  color: ${Color.gray}
`

const Loading = ({ height }) => (
  <Wrapper height={height}>
    <Icon name='spinner' size='3x' pulse />
  </Wrapper>
)

export default Loading



// WEBPACK FOOTER //
// ./src/components/UI/Loading.jsx